import { IcoDots } from '@icons';
import React from 'react';
import { Dropdown } from 'react-bootstrap';

type DropdownItemType = {
	key: string;
	label: React.ReactNode;
	action: () => void;
	icon: React.ReactNode | null;
};

interface SamplingInfoBoxDropdownProps {
	dropdownItems: DropdownItemType[];
}

const SamplingInfoBoxDropdown: React.FC<SamplingInfoBoxDropdownProps> = ({ dropdownItems }) => {
	return (
		<Dropdown align="end" className="no_caret-dropdown">
			<Dropdown.Toggle variant="link">
				<IcoDots width={48} height={48} />
			</Dropdown.Toggle>
			<Dropdown.Menu
				style={{
					overflow: 'hidden',
					minWidth: '260px',
				}}
			>
				{dropdownItems.map((item) => (
					<Dropdown.Item
						key={item.key}
						onClick={item.action}
						style={{
							padding: '0.5rem 1rem',
							display: 'grid',
							alignItems: 'center',
							justifyContent: 'center',
							gridTemplateColumns: item.icon ? '24px 1fr' : '1fr',
							gap: '0.5rem',
						}}
					>
						{item.icon}
						{item.label}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default SamplingInfoBoxDropdown;
